import React from 'react'
import { useTranslation } from 'react-i18next'
import { Grid } from '@mui/material'
import { Text } from '@pbt/pbt-ui-components'

import type { InventoryOrder } from '~/api/graphql/generated/types'

import { getReceivedBy } from '../utils'
import { OrderItemsPageHeaderLabels } from './OrderItemsPageHeaderLabels'
import { OrderItemsTableComponent } from './OrderItemsTableComponent'

interface OrderItemsPageProps {
  inventoryOrder: InventoryOrder
}

export const OrderItemsPage = ({ inventoryOrder }: OrderItemsPageProps) => {
  const { t } = useTranslation(['Admin', 'Common'])

  const receivedBy = getReceivedBy(inventoryOrder)

  return (
    <Grid
      container
      direction="column"
      height="100%"
      justifyContent="space-between"
      px={3}
      py={2}
    >
      <Grid item sx={{ mt: -2, ml: -3 }} xs={2}>
        <OrderItemsPageHeaderLabels
          inventoryOrder={inventoryOrder}
          receivedBy={receivedBy}
        />
      </Grid>
      <Grid item xs display="flex" flexDirection="column">
        <Text
          sx={(theme) => ({
            color: theme.colors.brandSecondary,
            fontWeight: theme.typography.fontWeightBold,
          })}
        >
          {t('Admin:CATALOG.ORDERS.ITEMS')}
        </Text>
        <OrderItemsTableComponent
          inventoryOrder={inventoryOrder}
          items={inventoryOrder.items}
        />
      </Grid>
    </Grid>
  )
}
